module.exports = __webpack_public_path__ + "img/picture_24.01c8d0b4.png";